function formatNotificationTime(createdDate) {
  if (!createdDate) {
    return "Just now";
  }

  const normalizedDate = createdDate.includes("T")
    ? createdDate
    : createdDate.replace(" ", "T");
  const createdAt = new Date(normalizedDate);

  if (Number.isNaN(createdAt.getTime())) {
    return createdDate;
  }

  const diffInMs = Date.now() - createdAt.getTime();
  const diffInMinutes = Math.max(0, Math.floor(diffInMs / 60000));

  if (diffInMinutes < 1) {
    return "Just now";
  }

  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
  }

  return createdAt.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function normalizeRedirectUrl(notification) {
  const redirectUrl = notification?.RedirectUrl || notification?.redirectUrl || "";

  if (!redirectUrl) {
    if (
      (notification?.EntityType || "").toLowerCase() === "job_forum_post" &&
      notification?.EntityId
    ) {
      return `/job-referral/${notification.EntityId}`;
    }

    return "/notifications";
  }

  if (redirectUrl.startsWith("/job-forum/post/")) {
    const postId = redirectUrl.split("/").pop();
    return `/job-referral/${postId}`;
  }

  return redirectUrl;
}

export function normalizeNotification(notification, index = 0) {
  const triggeredByName =
    `${notification?.TriggeredByFirstName || ""} ${
      notification?.TriggeredByLastName || ""
    }`.trim() || notification?.TriggeredByEmail || "";

  return {
    id:
      notification?.NotificationId ||
      notification?.notificationId ||
      notification?.id ||
      index,
    userId: notification?.UserId || notification?.userId || null,
    type: notification?.Type || notification?.type || "notification",
    title: notification?.Title || notification?.title || "Notification",
    message:
      notification?.Message || notification?.message || "You have a new update.",
    category:
      notification?.EntityType ||
      notification?.entityType ||
      notification?.Type ||
      "General",
    unread: !Boolean(notification?.IsRead || notification?.isRead),
    time: formatNotificationTime(
      notification?.CreatedDate || notification?.createdDate || "",
    ),
    createdDate: notification?.CreatedDate || notification?.createdDate || "",
    redirectUrl: normalizeRedirectUrl(notification),
    triggeredByName,
    raw: notification,
  };
}

export function countUnreadNotifications(notifications) {
  return notifications.filter((notification) => notification.unread).length;
}
